import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {MvsApiCrudServiceTagsInterface} from "../../../../core/shared/service/api/mvs-api-crud-service-tags.interface";

@Injectable({
  providedIn: 'root'
})
export class ContractTagService extends MvsCrudService implements MvsApiCrudServiceTagsInterface  {

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/cm/contractTags')
  }

  getTagAttribute(): string {
    return "";
  }

  getLinkedAttribute(objectType: string): string {

    return "contract";
  }

  getTagCategoryAttribute(): string {
    return "";
  }

  hasTagCategory(): boolean {
    return false;
  }
}
